export const internalOrgIdSearchParamKey = "organisation_id";
